module.exports = __webpack_public_path__ + "img/score-6.ff140fcc.png";